import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';
import { useDrawerContext } from '../../..';
import { DrawerChildrenProps } from '../types';

const DrawerBody = ({ children, ...restProps }: DrawerChildrenProps & Types.GlobalStylingProps) => {
  const { contentRef } = useDrawerContext();

  return (
    <Container overflowY="auto" flexGrow={1} padding={{ default: '6', sm: '8' }} ref={contentRef} {...restProps}>
      {children}
    </Container>
  );
};

DrawerBody.displayName = 'DrawerBody';

export default DrawerBody;
